module.exports = __webpack_public_path__ + "img/check.dd1c5ef1.jpg";